import { useWorkspaceMembers } from "../../hooks";
import { useWorkspaceTier } from "../../hooks/useWorkspaceTier";
import { MemberCard } from "./MemberCard";
import { auth } from "../../lib/firebase";

interface HumanMembersSectionProps {
  workspaceId: string;
  onInviteClick: () => void;
}

export function HumanMembersSection({ workspaceId, onInviteClick }: HumanMembersSectionProps) {
  const { members, loading, error, refetch } = useWorkspaceMembers(workspaceId);
  // track:workspace-write-auth (#48220 Track A, Outcome 4) — was
  // tier === 'read_only', the Agent Autonomy value that used to share this
  // same field. Billing tier now lives here alone, so choosing "Manual"
  // (Agent Autonomy) no longer hides Invite (track:workspace-controls-audit
  // #48218's finding).
  const { tier } = useWorkspaceTier(workspaceId);
  const isFreeTier = tier === 'free';
  const currentUserIsLead = members.some(
    (m) => m.user_id === auth.currentUser?.uid && m.role === "human_lead"
  );

  return (
    <section id="team-section-human" style={{ marginBottom: 32 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div className="sc-section-label" style={{ margin: 0, flex: 1 }}>
          Human Partners
        </div>
        {!isFreeTier && currentUserIsLead && (
          <button className="btn sm" onClick={onInviteClick}>
            + Invite
          </button>
        )}
      </div>

      {loading && <div style={{ fontSize: 13, color: "var(--muted)", fontFamily: "var(--font-ui)" }}>Loading partners...</div>}
      {error && <div className="sc-callout error">Error loading partners: {error.message}</div>}
      {!loading && !error && members.length === 0 && (
        <div style={{ fontSize: 13, color: "var(--muted)", fontFamily: "var(--font-ui)" }}>No partners found.</div>
      )}
      {!loading && !error && members.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {members.map((member) => (
            <MemberCard
              key={member.user_id}
              member={member}
              workspaceId={workspaceId}
              onRefetch={refetch}
              currentUserIsLead={currentUserIsLead}
            />
          ))}
        </div>
      )}
    </section>
  );
}
